module.exports = __webpack_public_path__ + "img/addDBL.1e5018da.svg";